import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { UIComponentViewImpl } from "../../../../toolkit/uicomponentview";
import { LoaderWrapperComponent } from "../../loaderwrappercomponent";
import { ConfirmFlashMessageComponentHandler, ConfirmFlashMessageComponentProps, ConfirmFlashMessageComponentState } from "./confirmflashmessagecomponent";
import { ConfirmFlashMessageCSSStyle } from "./confirmflashmessagecss";
import * as React from "react";
import { ButtonComponent } from "../../../../toolkit/button/buttoncomponent";
import { LoaderComponent } from "../../../../toolkit/loader/loadercomponent";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { ConfirmRequestConfirmButtonCSSStyleImpl } from "../../confirmrequest/confirmrequestconfirmbuttoncss";
import { SubscriptionPlanCancelButtonCSSStyleImpl } from "../../subscription_plan/subscriptionplancancelbuttoncss";
import './confirmflashmessage-style.css';

export class ConfirmFlashMessageViewImpl extends UIComponentViewImpl<FlashMessageDto>
{

    private loaderWrapperComponent:LoaderWrapperComponent;
    bindHandlers()
    {   
        this.onClosePopup = this.onClosePopup.bind(this);
        this.onNoClick = this.onNoClick.bind(this);
        this.onYesClick = this.onYesClick.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
    }

    draw(props: ConfirmFlashMessageComponentProps, state: ConfirmFlashMessageComponentState, cssStyle: ConfirmFlashMessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                {
                    this.getWebView(props, state, cssStyle)
                }

                  <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>

            </div>
        );
    }


    getWebView(props: ConfirmFlashMessageComponentProps, state: ConfirmFlashMessageComponentState, cssStyle: ConfirmFlashMessageCSSStyle):JSX.Element
    { 
        return(
            <>
                    <div style={cssStyle.getHeaderDivCSSStyle()}>
                        <label id="confirm-flash-header-title" style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                        <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onClosePopup}>
                            <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                        </div>
                    </div>
                    <div id="confirm-flash-msg-main">
                            <div id="confirm-flash-msg-header-main">
                                    <div id="confirm-flash-msg-main-div" style={{}}>
                                        <label id="confirm-flash-msg-label" style={{}}>
                                            {props.confirmMessage}
                                        </label>
                                    </div>
                             </div> 
                    </div>         
                     <div id="confirm-flash-msg-button-div" style={{}}>
                            <div id="confirm-flash-msg-button1-div" style={{}}>
                                <ButtonComponent onClick={this.onNoClick} style={new SubscriptionPlanCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                            </div>
                            <div id="confirm-flash-msg-button2-div" style={{ }}>
                                <ButtonComponent onClick={this.onYesClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.next)}/>
                            </div>
                    </div>         
            </>
        );
    }

    showLoader()
    {       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    onNoClick()
    {  
        (this.getUIComponentHandler() as ConfirmFlashMessageComponentHandler).onNoClick();
    }
    onYesClick()
    {
        (this.getUIComponentHandler() as ConfirmFlashMessageComponentHandler).onYesClick();
    }
    onClosePopup():void
    {
        (this.getUIProps() as ConfirmFlashMessageComponentProps).closePopup();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/confirmflashmessage/confirmflashmessageview.tsx